// @flow

import { serialize } from 'object-to-formdata';
import { hpfetch, hpfetchWithoutContentType, hpXHR } from '../util';
import type { offeringVideoType } from '../../types';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';

export const submit = (
  offeringId: number,
  video: File,
  onProgress: (number, ProgressEvent, string) => void,
  order: number,
) => {
  return hpfetch(`offerings/${offeringId}/videos/`, {
    method: 'POST',
    body: JSON.stringify({
      filename: video.name,
      initial_order: order,
    }),
  }).then(res => {
    const { fields, url } = res.body.presigned_url;
    const form = serialize(fields);
    form.append('file', video);

    const progressFunction = progressEvent => {
      onProgress(res.body.id, progressEvent, video.name);
    };

    return hpXHR(url, 'POST', form, progressFunction);
  });
};

export const getSingle = (
  offeringId: number,
  videoId: number,
): Promise<wrappedApiResponseType<offeringVideoType>> =>
  hpfetch(`offerings/${offeringId}/videos/${videoId}/`);

export const getMany = (
  offeringId: number,
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<offeringVideoType> =>
  hpfetch(`offerings/${offeringId}/videos/?limit=${limit}&offset=${offset}`);

export const deleteSingle = (offeringId: number, id: number) => {
  return hpfetch(`offerings/${offeringId}/videos/${id}/`, {
    method: 'DELETE',
  });
};

export const orderTo = (offeringId: number, id: number, toLocation: number) => {
  const endpoint = `offerings/${offeringId}/videos/${id}/to/${toLocation}/`;

  return hpfetchWithoutContentType(endpoint, {
    method: 'POST',
  });
};

export const bulkOrder = (offeringId: number, fields: any) => {
  hpfetch(`offerings/${offeringId}/videos/bulk_order/`, {
    method: 'PATCH',
    body: JSON.stringify(fields),
  });
};
